import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-mis-appropriation',
  templateUrl: './mis-appropriation.component.html',
  styleUrls: ['./mis-appropriation.component.scss']
})
export class MisAppropriationComponent {

  UserDetails: any;
  targetForm!: FormGroup;
  blockList: any[] = [];
  inspectionData: any[] = [];
  financialYears: any[] = [];
  circlesList: any[] = [];
  caseForm!: FormGroup;
  rows: any[] = [];
  months: any[] = [];
  showButton = false
  currentMonth: any = {};
  monthKeyMap: Record<number, string> = {
    1: 'april',
    2: 'may',
    3: 'june',
    4: 'july',
    5: 'august',
    6: 'september',
    7: 'october',
    8: 'november',
    9: 'december',
    10: 'january',
    11: 'february',
    12: 'march'
  };
  constructor(private reportService: ReportsService,private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],

    });


    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;

    // switch (this.UserDetails?.roleId) {
    //   case 13:
    //     this.targetForm.addControl('blockOffice', new FormControl(['', Validators.required]))
    //     // this.targetForm.get('blockOffice')?.valueChanges
    //     //   .pipe(skip(1)) // ignore the first emit
    //     //   .subscribe((val: any) => {
    //     //     if (this.targetForm.valid) {

    //     //     }
    //     //   });
    //     break;
    //   case 1:
    //     this.targetForm.get('circleOffice')?.valueChanges
    //       .pipe(skip(1)) // ignore the first emit
    //       .subscribe((val: any) => {
    //         if (this.targetForm.valid) {

    //         }
    //       });
    //     break;
    //   case 11:
    //     this.targetForm.addControl('blockOffice', new FormControl([Validators.required]))
    //     this.targetForm.controls['blockOffice'].disable();
    //     break;
    //   default:
    // }


    const today = new Date();
    const currentMonthYear = today.toISOString().slice(0, 7); // format: "2025-09"



    this.caseForm = this.fb.group({
      financialYear: [{ value: '', disabled: true }],
      blockOffice: [{ value: '', disabled: true }],
      dataMonth: [{ value: '', disabled: true }],
      cases: this.fb.array([
        this.fb.group({
          itemName: ['Court'],
          pendingCount: [{ value: 0, disabled: false }],
          pendingAmount: [{ value: 0, disabled: false }],
          freshCount: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
          freshAmount: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          decidedCount: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
          decidedAmount: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
        }),
        this.fb.group({
          itemName: ['Police'],
          pendingCount: [{ value: 0, disabled: false }],
          pendingAmount: [{ value: 0, disabled: false }],
          freshCount: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
          freshAmount: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          decidedCount: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
          decidedAmount: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
        })
      ])
    });

    switch (this.UserDetails?.roleId) {
      case 13:

        break;
      case 1:
        this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
        this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();


        break;
      default:
    }
    this.getTargetCount();
    this.GetYearAndMonth();
    this.targetForm.valueChanges
      .pipe(debounceTime(300))  // waits 300ms after last change
      .subscribe(() => {
        if (this.targetForm.valid) {
          this.GetMisappropriation();
        }
      });
  }
  get cases(): FormArray {
    return this.caseForm.get('cases') as FormArray;
  }
  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if (this.UserDetails?.roleId !== 1) {
          this.blockList = res.data.blocks;
        }

        this.financialYears = res.data.financialYears
        if (this.UserDetails?.roleId == 11) {
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
          this.targetForm.controls['blockOffice'].disable();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getCircle() {

    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;



      }
    },
      (error: any) => {
      }
    );
  }

  GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId": 0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }


    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {

        this.blockList = res.data?.block;
        this.targetForm.controls['blockOffice'].setValue('');

      }
    },
      (error: any) => {
      }
    );
  }
  GetMisappropriation() {
    let obj = {
      blockId: this.targetForm.getRawValue().blockOffice.toString(),
      "financialYear": this.targetForm.value?.financialYear?.financialYear
    }
    this.reportService.GetMisappropriation(obj).subscribe((res: any) => {

      if (res && res?.data && res?.data.length > 0) {

        let lastRow = res?.data[res?.data.length - 1];

        this.inspectionData = res?.data
        if (Number(lastRow?.dataMonth) != 12 && Number(lastRow?.dataMonth) < 12) {
          let fyear = this.targetForm.getRawValue()?.financialYear.financialYear
          let year = (Number(lastRow?.dataMonth) <= 9) ? fyear?.split('-')[0] : fyear.split('-')[1]
          this.currentMonth.key = (Number(lastRow?.dataMonth) + 1).toString();
          this.currentMonth.name = this.monthKeyMap[(Number(lastRow?.dataMonth) + 1)] + ', ' + year
          this.showButton = true
        } else {
          this.showButton = false
        }


      } else {
        this.inspectionData = [];
        this.showButton = true;
        this.currentMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.value?.financialYear?.startYear
        this.currentMonth.key = '1';
        this.toastService.showInfo('NO Data Found!')
      }
    },
      (error: any) => {
      }
    );
  }
  allowOnlyInteger(event: any, maxLength: number) {
    let input = event.target.value;

    input = input.replace(/\D/g, '');

    input = input.replace(/^0+/, '');

    if (input === '0') {
      input = '';
    }

    if (input.length > maxLength) {
      input = input.substring(0, maxLength);
    }

    event.target.value = input;
  }


  allowAmount(event: any, maxLength: number) {
    let input = event.target.value;

    input = input.replace(/[^0-9.]/g, '');

    const parts = input.split('.');
    if (parts.length > 2) {
      input = parts[0] + '.' + parts.slice(1).join('');
    }

    if (parts[1]?.length > 2) {
      input = parts[0] + '.' + parts[1].substring(0, 2);
    }

    if (input.length > maxLength) {
      input = input.substring(0, maxLength);
    }

    event.target.value = input;
  }

  GetYearAndMonth() {

    this.reportService.GetYearAndMonth({}).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;


        // this.financialYears = res.data.financialYears
        this.months = res.data.months


      }
    },
      (error: any) => {
      }
    );
  }
  addData() {
    let lastItem
    if (this.inspectionData && this.inspectionData.length > 0) {
      lastItem = this.inspectionData[this.inspectionData.length - 1]
    }
    this.caseForm.patchValue({
      financialYear: this.targetForm.value?.financialYear,
      blockOffice: this.targetForm.getRawValue()?.blockOffice,
      dataMonth: this.currentMonth.key,

    });

    const casesArray = this.caseForm.get('cases') as FormArray;
    casesArray.clear(); // Remove any default rows
    if (lastItem) {
      casesArray.push(this.fb.group({
        itemName: ['Court'],
        pendingCount: [{ value: (lastItem.courtPendingNo || 0) + (lastItem.courtFreshNo || 0) - (lastItem.courtDecidedNo || 0), disabled: true }],
        pendingAmount: [{ value: (lastItem.courtPendingAmt || 0) + (lastItem.courtFreshAmt || 0) - (lastItem.courtDecidedAmt || 0), disabled: true }],
        freshCount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
        freshAmount: [0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        decidedCount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
        decidedAmount: [0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
      }));

      casesArray.push(this.fb.group({
        itemName: ['Police'],
        pendingCount: [{ value: (lastItem.policePendingNo || 0) + (lastItem.policeFreshNo || 0) - (lastItem.policeDecidedNo || 0), disabled: true }],
        pendingAmount: [{ value: (lastItem.policePendingAmt || 0) + (lastItem.policeFreshAmt || 0) - (lastItem.policeDecidedAmt || 0), disabled: true }],
        freshCount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
        freshAmount: [0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        decidedCount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
        decidedAmount: [0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
      }));
    }
    else {
      casesArray.push(this.fb.group({
        itemName: ['Court'],
        pendingCount: [{ value: 0, disabled: false }],
        pendingAmount: [{ value: 0, disabled: false }],
        freshCount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
        freshAmount: [0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        decidedCount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
        decidedAmount: [0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
      }));

      casesArray.push(this.fb.group({
        itemName: ['Police'],
        pendingCount: [{ value: 0, disabled: false }],
        pendingAmount: [{ value: 0, disabled: false }],
        freshCount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
        freshAmount: [0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        decidedCount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
        decidedAmount: [0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
      }));
    }
  }
  submitForm() {
    if (this.caseForm.invalid) {
      this.caseForm.markAllAsTouched();
      return;
    }

    const formValue = this.caseForm.getRawValue(); // includes disabled values

    const court = formValue.cases.find((c: any) => c.itemName === 'Court');
    const police = formValue.cases.find((c: any) => c.itemName === 'Police');

    const payload = {

      financialYear: formValue.financialYear?.financialYear,
      dataMonth: formValue.dataMonth,
      blockOffice: formValue.blockOffice,

      courtPendingNo: Number(court.pendingCount || 0),
      courtPendingAmt: Number(court.pendingAmount || 0),
      courtFreshNo: Number(court.freshCount || 0),
      courtFreshAmt: Number(court.freshAmount || 0),
      courtDecidedNo: Number(court.decidedCount || 0),
      courtDecidedAmt: Number(court.decidedAmount || 0),

      policePendingNo: Number(police.pendingCount || 0),
      policePendingAmt: Number(police.pendingAmount || 0),
      policeFreshNo: Number(police.freshCount || 0),
      policeFreshAmt: Number(police.freshAmount || 0),
      policeDecidedNo: Number(police.decidedCount || 0),
      policeDecidedAmt: Number(police.decidedAmount || 0),

      "createdBy": this.edit ? 0 : this.UserDetails?.id,
      "modifiedBy": this.edit ? this.UserDetails?.id : 0,
      id: this.edit ? this.editId : 0
    };


    // Call your API service

    this.reportService.AddMisappropriation(payload).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);

          this.hideModal('MisappropriationEmbezzlementCasesModal');
          this.caseForm.markAsUntouched();
          this.GetMisappropriation();
          this.caseForm.reset();

        }

      }
      this.edit = false
    },
      (error: any) => {
      }
    );
  }


  onSubmit() {
    if (this.caseForm.valid) {
      // 🔑 getRawValue() ensures disabled fields are included
      const payload = this.caseForm.getRawValue();
      // let entryYear = this.reportingYears.find((i) => i?.startYear == payload?.financialYear)
      let obj = {


        "blockOffice": Number(payload?.blockOffice),
        "financialYear": payload?.financialYear?.financialYear?.toString(),
        "dataMonth": payload?.dataMonth,

        "totalFPS": payload?.noOfFps,
        "inspectionsDuringMonth": payload?.noOfInspectionDone,


        // "inspectionsDuringMonth": "string",
        "inspectionsUptoMonth": payload?.noOfFps + payload?.noOfInspectionDone,



        "createdBy": this.edit ? 0 : this.UserDetails?.id,
        "modifiedBy": this.edit ? this.UserDetails?.id : 0,
        id: this.edit ? this.editId : 0

      }


      this.reportService.AddTFPSInspectionDetails(obj).subscribe((res: any) => {
        if (res) {

          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideModal('MisappropriationEmbezzlementCasesModal');
            this.caseForm.reset();
            this.caseForm.markAsUntouched();
            this.GetMisappropriation();
          }

        }
        this.edit = false
      },
        (error: any) => {
        }
      );


    } else {
      this.caseForm.markAllAsTouched();
    }
  }

  edit = false;
  editId = 0


  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }

  editRow(row: any) {

    const caseData: any = row;
    const headerData = this.targetForm.getRawValue();
    this.caseForm.patchValue({
      financialYear: headerData.financialYear,
      blockOffice: caseData.blockOffice,
      dataMonth: caseData?.dataMonth.toString(),
    });

    const casesArray = this.caseForm.get('cases') as FormArray;
    casesArray.clear(); // Remove any default rows

    casesArray.push(this.fb.group({
      itemName: ['Court'],
      pendingCount: [{ value: caseData.courtPendingNo, disabled: false }],
      pendingAmount: [{ value: caseData.courtPendingAmt, disabled: false }],
      freshCount: [caseData.courtFreshNo, [Validators.required, Validators.pattern(/^\d+$/)]],
      freshAmount: [caseData.courtFreshAmt, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      decidedCount: [caseData.courtDecidedNo, [Validators.required, Validators.pattern(/^\d+$/)]],
      decidedAmount: [caseData.courtDecidedAmt, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
    }));

    casesArray.push(this.fb.group({
      itemName: ['Police'],
      pendingCount: [{ value: caseData.policePendingNo, disabled: false }],
      pendingAmount: [{ value: caseData.policePendingAmt, disabled: false }],
      freshCount: [caseData.policeFreshNo, [Validators.required, Validators.pattern(/^\d+$/)]],
      freshAmount: [caseData.policeFreshAmt, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      decidedCount: [caseData.policeDecidedNo, [Validators.required, Validators.pattern(/^\d+$/)]],
      decidedAmount: [caseData.policeDecidedAmt, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
    }));


    this.editId = caseData?.id
    this.edit = true

    this.openModal('MisappropriationEmbezzlementCasesModal');
  }

  DeleteMisappropriation(id: any) {
    this.reportService.DeleteMisappropriation(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.GetMisappropriation();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  verifyMisappropriation(id: any) {
    this.reportService.verifyMisappropriation(id).subscribe((res: any) => {
      if (res) {

        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.GetMisappropriation();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  getMonthName(month: string | number): string {
    const months = [
      'April', 'May', 'June', 'July', 'August', 'September',
      'October', 'November', 'December', 'January', 'February', 'March'
    ];
    const index = +month - 1;
    return months[index] || 'Unknown';
  }

  getYearFromFinancialYear(financialYear: string, month: string | number): string {
    const [startYear, endYear] = financialYear.split('-');
    const monthNum = +month;
    return monthNum >= 1 && monthNum <= 9 ? startYear : endYear;
  }
  deleteIndex: any
  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete() {
    this.deleteIndex = 0;

  }
  closeModel() {
    // this.caseForm.reset()
    this.caseForm.markAsUntouched()
    this.editId = 0
    this.edit = false
  }
}
